import { AsProp, NullableClassName } from '@squareup/dex-types-shared-ui';
import { Paragraph30 } from '@squareup/dex-ui-shared-base';
import clsx from 'clsx';
import React, { FunctionComponent } from 'react';

import styles from './http-method-string.module.css';

type HttpMethods = 'GET' | 'PUT' | 'POST' | 'DELETE' | 'EVENT' | 'DEPRECATED';

export interface HttpMethodStringProps {
  httpMethod: HttpMethods;
}

const HttpMethodString: FunctionComponent<
  HttpMethodStringProps & AsProp & NullableClassName
> = ({ httpMethod, as, className }) => {
  return (
    <Paragraph30
      weight="medium"
      as={as}
      className={clsx(styles[httpMethod], className)}
    >
      {httpMethod}
    </Paragraph30>
  );
};

export { type HttpMethods, HttpMethodString };
